import { render } from "./TraiterDemandeInscriptionPage.vue?vue&type=template&id=fc34410a&ts=true"
import script from "./TraiterDemandeInscriptionPage.vue?vue&type=script&lang=ts"
export * from "./TraiterDemandeInscriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__